import React, { useState, useEffect } from "react";
import "./Login.css";

const API_BASE_URL =
  process.env.REACT_APP_API_URL || "https://localhost:3443";

function Login({ onLogin }) {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const sessionParam = urlParams.get("session");

    if (sessionParam) {
      checkSession(sessionParam);
      window.history.replaceState({}, document.title, window.location.pathname);
    }
  }, []);

  const checkSession = async (sessionId) => {
    try {
      const response = await fetch(`${API_BASE_URL}/api/auth/check`, {
        headers: { Authorization: `Bearer ${sessionId}` },
      });
      const data = await response.json();

      if (data.authenticated && data.user) {
        onLogin(data.user, sessionId);
      }
    } catch (err) {
      console.error("Erreur lors de la vérification de session:", err);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setError("");

    try {
      const response = await fetch(`${API_BASE_URL}/api/auth/login`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ username: username.trim(), password }),
      });

      const data = await response.json().catch(() => ({}));

      if (response.ok && data.success && data.sessionId && data.user) {
        onLogin(data.user, data.sessionId);
        return;
      }

      setError(data.message || "Identifiants incorrects ou erreur serveur.");
    } catch (err) {
      console.error("Erreur lors de la connexion:", err);
      setError("Impossible de joindre le serveur. Vérifiez l'URL de l'API.");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="login-container">
      <div className="login-card">
        <div className="login-header">
          <div className="login-logo">
            <span className="logo-icon">🎮</span>
          </div>
          <h1>PPFBot</h1>
          <p>Connexion requise</p>
        </div>

        <div className="login-content">

          {error && (
            <div className="error-message">
              <span className="error-icon">⚠️</span>
              {error}
            </div>
          )}

          <form className="login-form" onSubmit={handleSubmit}>
            <label className="login-label" htmlFor="login-username">
              Nom d&apos;utilisateur
            </label>
            <input
              id="login-username"
              className="login-input"
              type="text"
              autoComplete="username"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              disabled={isLoading}
              required
            />

            <label className="login-label" htmlFor="login-password">
              Mot de passe
            </label>
            <input
              id="login-password"
              className="login-input"
              type="password"
              autoComplete="current-password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              disabled={isLoading}
              required
            />

            <button
              type="submit"
              className={`login-submit-btn ${isLoading ? "loading" : ""}`}
              disabled={isLoading}
            >
              {isLoading ? (
                <>
                  <div className="spinner"></div>
                  Connexion en cours...
                </>
              ) : (
                "Se connecter"
              )}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}

export default Login;
